import { render, staticRenderFns } from "./BotaoContratoRastreabilidadeCadastrante.vue?vue&type=template&id=c1b7a2f4&lang=pug"
import script from "./BotaoContratoRastreabilidadeCadastrante.vue?vue&type=script&lang=js"
export * from "./BotaoContratoRastreabilidadeCadastrante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports